import { storeToRefs } from 'pinia';
import { DrawerInfo } from '../../stores/core/models';
import { useCoreStore } from '../../stores/core/store';
import useRouteUtils from '../router-utils/route-utils';

export default () => {
  const coreStore = useCoreStore();
  const { drawerInfo, sizes, drawerContainerData } = storeToRefs(coreStore);
  const { getMostInnerTableBasedContainerType } = useRouteUtils();

  const showDrawer = (info: DrawerInfo) => {
    drawerInfo.value = info;
  };

  const setIsDirty = (value: boolean) => (drawerContainerData.value.isDirty = value);

  const setDataOnShelf = (data: any) => (drawerContainerData.value.shelfData = data);

  const getDataFromShelf = () => drawerContainerData.value.shelfData;

  const getDrawerData = <T>() => drawerInfo.value?.data as T;

  const closeDrawer = () => {
    console.log('closeDrawer');
    setIsDirty(false);
    drawerInfo.value = undefined;
    drawerContainerData.value.afterClosedCnt++;
  };

  const closeDrawerAndRefreshTableBasedContainer = () => {
    const tableBasedContainer = getMostInnerTableBasedContainerType();
    if (tableBasedContainer) coreStore.refreshTableBasedContainer(tableBasedContainer);

    drawerContainerData.value.selectedKeys = [];
    drawerContainerData.value.selectedRows = [];

    closeDrawer();
  };

  return {
    sizes,
    setIsDirty,
    showDrawer,
    closeDrawer,
    getDrawerData,
    setDataOnShelf,
    getDataFromShelf,
    closeDrawerAndRefreshTableBasedContainer,
  };
};
